import { motion } from "framer-motion";
import PropTypes from "prop-types";
import { MODAL_VARIANTS } from "../../../../constants/animations";

/**
 * ModalBackdrop - Reusable modal backdrop with blur animation
 * 
 * Provides a consistent backdrop for all modals with smooth blur
 * animation. Automatically handles click-to-close functionality.
 * 
 * @component
 * @example
 * ```jsx
 * import { ModalBackdrop } from "../ui/Motion";
 * import { AnimatePresence } from "framer-motion";
 * 
 * <AnimatePresence>
 *   {isOpen && (
 *     <>
 *       <ModalBackdrop onClick={handleClose} />
 *       {/* Modal content here *\/}
 *     </>
 *   )}
 * </AnimatePresence>
 * ```
 */
export const ModalBackdrop = ({
    onClick,
    className = "fixed inset-0 bg-black bg-opacity-10 z-10",
    ...props
}) => (
    <motion.div
        variants={MODAL_VARIANTS.backdrop}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.2 }}
        className={className}
        onClick={onClick}
        {...props}
    />
);

ModalBackdrop.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string
};

export default ModalBackdrop;
